import { NetworkStatus } from '@cbridge-utils/network';
import { IAlertsDataState } from './alertSubscription.interface';

export const initialAlertsDataState: IAlertsDataState = {
  subscriptions: [],
  emails: [],
  processing: false,
  processingCells: new Set(),
  networkStatus: NetworkStatus.None,
};
